module.exports = __webpack_public_path__ + "static/img/icon_axdh.74060e6b.png";